import PushNotifications from './controllers/push-notifications-controller';
import { OS_CODE_NUMBER, APP_VERSION } from './controllers/static';

export default new PushNotifications(OS_CODE_NUMBER, APP_VERSION);
